module.exports = __webpack_public_path__ + "static/media/Rosaria.a935e650.png";